import { RESEARCH_MODE_SOURCES_ENDPOINT } from 'api/constants';
import { api } from 'store/api/api';

import type { GetSourcesResponse } from 'modules/shared/api/sources.api.types';

const researchSourcesApi = api
  .enhanceEndpoints({
    addTagTypes: ['ResearchModeSources'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getResearchModeSources: builder.query<GetSourcesResponse, void>({
        query: () => ({
          url: RESEARCH_MODE_SOURCES_ENDPOINT,
          method: 'GET',
          credentials: 'include',
        }),
        providesTags: ['ResearchModeSources'],
        keepUnusedDataFor: 1800, // 30 minute cache - sources don't change frequently
      }),
    }),
  });

export const { useGetResearchModeSourcesQuery } = researchSourcesApi;
